import React, {
  memo,
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useCallback,
  useMemo,
} from 'react';
import { createSelector } from 'reselect';
import style from './DiscRecommendCard.module.less';
import { DISCOUNT_RECOMMEND_APPTYPEENUM } from '../../../constants/discount';
import BuyDarkIcon from '../../../static/discount/buy-dark.svg';
import BuyLightcon from '../../../static/discount/buy-light.svg';
import useInterval from '../../../utils/hooks/useInterval';
import DiscountBtn from '../../DiscountBtn/DiscountBtn';
import { useDispatch, useSelector } from 'react-redux';
import { setIframeVisible } from '../../../actions/layout';
import { logging, logPostInfo } from '../../../actions/log';
import { addClass, changeClass, removeClass, getSoftType } from '../../../utils/utils';
import { CONTEXT } from '../../../config';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { gameCDKSetVisible } from '../../../actions/gamecdk';
import discountcardDefaultGameUrl from '../../../static/discount/discountcard-default-game.png';
import discountcardDefaultOthersUrl from '../../../static/discount/discountcard-default-other.png';
import loading from '../../../static/loading.gif';
import DiscountPrice from '../DiscountPrice/DiscountPrice';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectLoginClose = createSelector(
  state => state.user,
  user => user.loginBoxClose,
);

export default memo(props => {
  const { item_card, index_card, soft } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const userInfo = useSelector(selectUserInfo);
  const remainDiscountTimeStr = useInterval(item_card.discountEndTime);
  const priceRef = useRef(null);
  const imgNode = useRef(null);
  const [showOriginalPrice, setShowOriginalPrice] = useState(true);
  const [isClickBtn, setIsClickBtn] = useState(false);
  const [vImg, setVImg] = useState();
  const loginBoxClose = useSelector(selectLoginClose);

  const show = () => {
    return new Promise((re, rj) => {
      const img = new Image();
      img.onload = () => re(item_card?.vImg);
      img.src = loading;
    });
  };

  useEffect(() => {
    // let img = new Image();
    if (item_card?.vImg) {
      // img.src = item_card.vImg;
      // img.onload = () => {
      //   setVImg(item_card.vImg);
      // };

      show().then(res => {
        setVImg(res);
      });
    } else {
      setVImg(item_card.type === 1 ? discountcardDefaultGameUrl : discountcardDefaultOthersUrl);
    }
  }, []);

  const handleCard = info => {
    let param3 = {};
    try {
      param3 = JSON.parse(info?.bizInfo);
    } catch (e) {
      param3 = {};
    }
    if (info?.type === 1 || info?.type === 3) {
      dispatch(
        logging({
          category: 'C',
          action: 'handle_SoftCard',
          label: '',
          param2: {
            softType: getSoftType(info?.extInfo?.appInfo),
            softid: info?.extInfo?.appInfo.softID,
            source: 'Sales_Reco',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
          param3: param3,
        }),
      );
    } else {
      let param2 = {
        source: 'Sales_Reco',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        type: info?.type,
        id: info?.id,
      };

      // 按钮点击打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Sales_Card_Detail',
          label: '',
          param2: param2,
          param3: param3,
        }),
      );
    }
    if ([1, 3].includes(info?.type) && info?.extInfo?.appInfo) {
      dispatch(
        logPostInfo({
          source_p: `Sales_Reco`,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(
        `${CONTEXT}/detail/soft/${info?.extInfo?.appInfo.softID}/${
          info?.extInfo?.appInfo.bizInfo || '{}'
        }`,
      );
    } else {
      if (info?.extInfo?.sourceType === 1) {
        dispatch(
          setIframeVisible({
            visible: true,
            url: info?.extInfo?.sourceUrl,
            soft,
            source: 'Sales_Reco',
          }),
        );
      } else if (info.extInfo?.sourceType === 2) {
        if (userInfo && userInfo?.st) {
          let gameCdkPrice = 0;
          let gameCdkSid = 0;
          try {
            let priceStr = info?.currentPrice || info?.originalPrice;
            gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
            gameCdkSid = info?.extInfo?.sid;
          } catch (error) {}
          dispatch(
            gameCDKSetVisible({
              isShow: true,
              soft: { gameCdkPrice, gameCdkSid },
              source: 'Sales_Reco',
            }),
          );
        } else {
          setIsClickBtn(true);

          window.CallNativeMethod('logout');
          window.CallNativeMethod('login');
        }
      } else {
        window.open(info?.extInfo?.sourceUrl);
      }
    }
  };
  const tags = useMemo(() => {
    const salesTags = item_card.labels?.find(item => item.type === '21');
    const herdTags = item_card.labels?.find(item => item.type === '22');
    const rankTags = item_card?.labels
      ?.filter(item => item.type?.startsWith('1') || item.type?.startsWith('3'))
      .slice(0, 4);
    return {
      herdTags: herdTags || [],
      rankTags: rankTags || [],
      salesTags: salesTags || [],
    };
  }, [item_card]);

  const isShowSecondItems = (origin, cur) => {
    return origin.length + cur.length < 10;
  };

  const onMouseOver = e => {
    removeClass(imgNode.current, style.image_mouse_out);
    addClass(imgNode.current, style.image_mouse_in);
  };

  const onMouseLeave = e => {
    addClass(imgNode.current, style.image_mouse_out);
    removeClass(imgNode.current, style.image_mouse_in);
  };

  const handleImgOnError = type => {
    return type === 1 ? discountcardDefaultGameUrl : discountcardDefaultOthersUrl;
  };

  useEffect(() => {
    if (isClickBtn && loginBoxClose?.result === 0) {
      setIsClickBtn(false);
    }
  }, [loginBoxClose, isClickBtn]);

  useEffect(() => {
    if (userInfo && userInfo?.st && isClickBtn) {
      let gameCdkPrice = 0;
      let gameCdkSid = 0;
      try {
        let priceStr = soft?.currentPrice || soft?.originalPrice;
        gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
        gameCdkSid = soft?.sid;
      } catch (error) {}
      dispatch(
        gameCDKSetVisible({
          isShow: true,
          soft: { gameCdkPrice, gameCdkSid },
          source: logInfo.source,
        }),
      );
      setIsClickBtn(false);
    }
  }, [isClickBtn, userInfo]);

  // useEffect(() => {
  //   if (priceRef.current.clientWidth >= 75) {
  //     setShowOriginalPrice(false);
  //   } else {
  //     setShowOriginalPrice(true);
  //   }
  // }, [priceRef]);

  // useEffect(() => {}, [remainDiscountTimeStr]);

  return (
    <div
      style={{ height: item_card.height }}
      className={`${style.DiscRecommendCard} ${style[item_card.styleType[0]]} ${
        style[item_card.styleType[1]]
      }`}
      onClick={() => handleCard(item_card)}
      onMouseEnter={() => {
        onMouseOver();
      }}
      onMouseLeave={() => {
        onMouseLeave();
      }}
    >
      {remainDiscountTimeStr && (
        <div className="remain-discount-time">
          <div>
            剩余<span>{remainDiscountTimeStr}</span>结束
          </div>
        </div>
      )}
      <div
        className="img-content"
        // style={{ backgroundImage: `url(${item_card.hImg})` }}
      >
        <img
          src={vImg}
          onError={() => handleImgOnError(item_card.type)}
          alt="img"
          className="img"
          ref={imgNode}
        />
        <div className="img-tag">{DISCOUNT_RECOMMEND_APPTYPEENUM[item_card.type].name}</div>
      </div>
      <div className="info-content">
        <div className="app-name">{item_card?.name}</div>
        <div className="app-desc">{item_card?.description}</div>
        <div className="tag-content">
          {tags?.rankTags?.map((item, index) => {
            if (index === 0 && item?.type?.startsWith('1')) {
              return (
                <div className="discount-tag" key={index}>
                  {item.name}
                </div>
              );
            } else {
              return (
                <div className="rank-tag" key={index}>
                  {item.name}
                </div>
              );
            }
          })}
        </div>
        <div className="empty_line"></div>
        <div className="herd-tags">
          <div className="herd-tag-sales">{tags.salesTags.name}</div>
          <div className="herd-tag-item">{tags.herdTags.name}</div>
        </div>
        <DiscountPrice soft={item_card} source={'Sales_Reco'} />
        {/* <div className="pay-content">
          {item_card.currentPrice && item_card.currentPrice !== item_card.originalPrice && (
            <div className="discount">
              {Math.round((item_card.currentPrice / item_card.originalPrice) * 10 * 10) / 10 === 0
                ? 0.1
                : Math.round((item_card.currentPrice / item_card.originalPrice) * 10 * 10) / 10}
              <div> 折</div>
            </div>
          )}

          <div className="pay">
            <div className="price" ref={priceRef}>
              {item_card.currentPrice && item_card.currentPrice !== item_card.originalPrice ? (
                <>
                  <p className="fs-12">￥</p>
                  <p className="number">{item_card.currentPrice}</p>
                  {showOriginalPrice && <p className="fs-12 del">￥{item_card.originalPrice}</p>}
                </>
              ) : (
                <>
                  <span className="fs-12">￥</span> {item_card.originalPrice}
                </>
              )}
            </div>
  
            <div
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <div className="btn-style">
                <DiscountBtn
                  soft={item_card}
                  info={{
                    className: item_card.type === 1 ? 'other-btn' : 'other-btn',
                    tagClass: item_card.type === 1 ? style.btn_tag : style.btn_tag,
                  }}
                  logInfo={{ source: 'Sales_Reco' }}
                />
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
});
